// Edit these values to customize the landing page for your brand.
export const siteConfig = {
  brandName: "Lapak Bordir",
  tagline: "Bordir Komputer Profesional",
  whatsappNumber: "6281818110772", // Format internasional tanpa "+"
  whatsappDisplay: "0818-1811-0772",
  whatsappMessage: "Halo Lapak Bordir, saya tertarik dengan jasa bordir komputer. Mohon info lebih lanjut.",
  email: "info@lapakbordir.id",
  city: "Indonesia",
  marketplaceLabel: "Marketplace Terpercaya",
  images: {
    hero: "/images/bordir-seragam-kantor-lapakbordir.jpg",
    heroSecondary: "/images/mesin-bordir-komputer.png",
    detail: "/images/bordir-kemeja-lapakbordir.jpg",
    machine: "/images/bordir-komputer-lapakbordir.png",
    gallery: [
      "/images/bordir-kemeja-lapakbordir.jpg",
      "/images/bordir-seragam-kantor-lapakbordir.jpg",
      "/images/bordir-topi-lapakbordir.jpg",
      "/images/bordir-handuk-souvenir-lapakbordir.jpg",
      "/images/boneka-bordir-lapakbordir.png",
      "/images/bordir-jaket-komunitas-lapakbordir.jpg",
    ],
  },
};

export const waLink = (msg) => {
  const text = encodeURIComponent(msg || siteConfig.whatsappMessage);
  return `https://wa.me/${siteConfig.whatsappNumber}?text=${text}`;
};
